import { ASSIGN_TO_SUPERADMIN } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const assignToSuperadmin = createAsyncThunk('assignToSuperadminApi', async (obj: any) => {

  try {

    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = ASSIGN_TO_SUPERADMIN
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },

      body: JSON.stringify(obj)

    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default assignToSuperadmin;
